import { Component, AfterViewInit, OnInit, Input , EventEmitter, Output} from '@angular/core';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { RouteInfo } from "./sidebar.metadata";
import { Router, ActivatedRoute } from "@angular/router";
import { ROUTES } from '../../menu-items';
import { Theme } from '../service/AutoTheme';

declare var $: any;
@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html'
  
})
export class SidebarComponent implements OnInit {
    @Input() isSidebarOpen!: boolean;
    @Output() toggleSidebarEvent = new EventEmitter<void>();
    public hide = false;
    public  menu :  boolean;
    hoveredItem: string | null = null;
    showSubMenu: string = '';
    public sidebarnavItems: any[];
    //this is for the open close
   
    addActiveClass(element: any) {
        if (element === this.showSubMenu) {
            this.showSubMenu = '0';
            
        } else {
            this.showSubMenu = element; 
        }
    }
    
    constructor(private modalService: NgbModal, private router: Router,
        private route: ActivatedRoute ,  public theme:Theme ) {
        
    } 
    // End open close
    ngOnInit() {

        // console.log('Sidebar state changed:', this.isSidebarOpen);
        this.theme.showmenu.subscribe(res=>{
            if(sessionStorage.getItem('type') == "4")
            {
                /* if(parseInt(sessionStorage.getItem("id_package")) > 0)
                    this.menu= res;
                else
                    this.menu = false; */
                if(parseInt(sessionStorage.getItem("id_package")) < 1)
                    this.menu= false;
                else
                    this.menu = res;
            }
            else
            {
                this.menu= res;
            }
        });



        let menu= new ROUTES();
        this.sidebarnavItems = menu.Menuitem.filter(sidebarnavItem => sidebarnavItem);
        $(function () {
            $(".sidebartoggler").on('click', function() {
                if ($("#main-wrapper").hasClass("mini-sidebar")) {
                    $("body").trigger("resize");
                    $("#main-wrapper").removeClass("mini-sidebar");
                     
                } else {
                    $("body").trigger("resize");
                    $("#main-wrapper").addClass("mini-sidebar");
                }
            });

        });
        
    }

    toggleSidebar() {
        this.toggleSidebarEvent.emit(); 
      }

    showSettings()
    {}
    addExpandClass()
    {}

    onShowValue()
    {
        this.hide= true;
        // console.log('h');
    }
    // over(event: Event, hover: boolean)
    // {
    //     // console.log('ankur');
    //     // this.hide= false;
    //     this.isHovered = hover;

    // }
    over(title: string, hover: boolean) {
        this.hoveredItem = hover ? title : null;
    }
    

    ClickLogo() {
        let dashreport = parseInt(sessionStorage.getItem("isreport"));
        if (dashreport == 1)
            this.router.navigate(['/login/ndsisense']);
        else
            this.router.navigate(['/dashboards/dashboard6']);
    }

    
}
